<app-view-title [isSplitColor]="true" Title="{{ 'Intellitrailer.Rental.TakePictures.Headline' | translate : 'Photos' }}"></app-view-title>
<view-content [centered]="true">
  @if(!ignoreCameraCheck && appService.Device.Camera < 2) {
  <app-cameraPermissionRequired (next)="skipCameraCheck()" [(permissionAsked)]="permissionAsked"></app-cameraPermissionRequired>
  }
  @if(ignoreCameraCheck || appService.Device.Camera >= 2) {
  @if(event != 'Pickup') {
  <mat-horizontal-stepper labelPosition="bottom" linear #stepper [(selectedIndex)]="currentStep" (selectionChange)="onSelectionChange($event)">

    <!-- Custom States -->
    <ng-template matStepperIcon="image">
      <mat-icon>image</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="last">
      <mat-icon>done_all</mat-icon>

      <!-- Done State -->
    </ng-template>
    <ng-template matStepperIcon="done">
      <mat-icon>done</mat-icon>
    </ng-template>

    <!-- Changes the Edit Button state -->
    <ng-template matStepperIcon="edit">
      <mat-icon>camera</mat-icon>
    </ng-template>

    <!-- Loops through our angle list for object, creates a stepper for each -->
    <mat-step *ngFor="let photo of photos" state="image" [stepControl]="photo.control">
      <ng-template matStepperIcon>
      </ng-template>

      <h3>{{ photo.angle?.Name | translate  }}</h3>
      <div class="photo-container">
        <app-photo-view #appPhotoView [photo]="photo" [event]="event" bookingId="{{ booking?.Id }}" (failed)="photoFailed()" (completed)="photoTaken(photo)" (deleted)="photoDeleted(photo)"></app-photo-view>
      </div>
      <p class="photo-description">{{ photo.angle?.Description | translate  }}</p>

    </mat-step>

    <!-- Summary of the Images taken -->
    <mat-step state="last">
      <ng-template matStepperIcon></ng-template>
      <h3>{{ 'Intellitrailer.Rental.Summary.Summary' | translate : 'Summary' }}</h3>
      <div class="summary-container">
        <ng-container *ngFor="let photo of photos">
          <p> {{ photo.angle?.Name | translate }} </p>
          <img [src]="photo?.photoUri ? photo.photoUri : photo?.data ? 'data:image/jpg;base64,' + photo.data : fallbackImage" (click)="goToStep(photo)" />

        </ng-container>
        <h3> {{ 'Intellitrailer.Rental.Summary.AdditionalPhotos' | translate : 'Additional Photos' }}</h3>
        <app-photo-view *ngFor="let p of additionalPhotosArray; let index = index" [event]="event" [photo]="p" [additionalPhoto]="true" bookingId="{{ booking?.Id }}" (failed)="photoFailed()" (completed)="additionalPhotoTaken(p)" (deleted)="additionalPhotoDeleted(p)"></app-photo-view>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
  }
  @else {
  <h3>{{ 'Intellitrailer.Rental.Pickup.DocumentIssue' | translate : 'Document Issue or Damage' }}</h3>
  <p> {{ 'Intellitrailer.Rental.Pickup.DocumentDescription' | translate : 'Please take a clear picture to document any issues or damage you´ve noticed with the trailer.' }}</p>
  <app-photo-view *ngFor="let p of additionalPhotosArray; let index = index" [event]="event" [photo]="p" [additionalPhoto]="true" bookingId="{{ booking?.Id }}" (failed)="photoFailed()" (completed)="additionalPhotoTaken(p)" (deleted)="additionalPhotoDeleted(p)"></app-photo-view>
  }
  }

</view-content>
<view-actions mode="transparent">
  @if(event == 'Pickup') {<button mat-raised-button color="primary" [disabled]="additionalPhotosArray.length <= 1" (click)="confirm()">{{ 'Intellitrailer.Rental.PhotoBtn.Confirm' | translate: 'Confirm'}}</button> }
  @else{
  @if(stepper) {
  @if(stepper.selected?.stepControl?.valid) { <button mat-raised-button color="primary" (click)="stepper.next()">{{ 'Intellitrailer.Rental.PhotoBtn.Next' | translate: 'Next'}}</button> }
  @if(!stepper.selected?.stepControl) { <button mat-raised-button color="primary" (click)="confirm()">{{ 'Intellitrailer.Rental.PhotoBtn.Confirm' | translate: 'Confirm'}}</button> }
  }
  }
  @if(stepper?.selected?.stepControl?.invalid) { <button mat-raised-button color="primary" (click)="simulateChildClick()">{{ 'Intellitrailer.Rental.PhotoBtn.TakePicture' | translate: 'Take Picture'}}</button> }
  @if(!ignoreCameraCheck && appService.Device.Camera < 2 && permissionAsked){
  <a (click)="skipTakePictures()">{{ 'Intellitrailer.Rental.TakePictures.cmdSkip' | translate : 'Skip' }}</a>
  }
</view-actions>

